export default __webpack_public_path__ + "static/media/Cartão de Natal - Opção 05.e3087c9b.png";